import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * PageTransition
 * Wraps page content with a fade-in + translateY entry animation
 * on every route change. Uses CSS keyframes from animations.css.
 */
const PageTransition = ({ children }) => {
  const location = useLocation();
  const [displayKey, setDisplayKey] = useState(location?.pathname);
  const [isVisible, setIsVisible] = useState(true);
  const prevPathRef = useRef(location?.pathname);

  useEffect(() => {
    if (location?.pathname !== prevPathRef?.current) {
      // Trigger exit then enter
      setIsVisible(false);
      const exitTimer = setTimeout(() => {
        prevPathRef.current = location?.pathname;
        setDisplayKey(location?.pathname);
        setIsVisible(true);
      }, 180); // matches --anim-page-exit
      return () => clearTimeout(exitTimer);
    }
  }, [location?.pathname]);

  return (
    <div
      key={displayKey}
      className={isVisible ? 'page-transition-enter' : 'page-transition-exit'}
      style={{ minHeight: '100%', width: '100%' }}
    >
      {children}
    </div>
  );
};

export default PageTransition;
